import { EPSG } from "../../../lib/projection";
export class MapServiceApi {
    constructor(urls, service_info, _token) {
        this.urls = urls;
        this.service_info = service_info;
        this._token = _token;
        this.layer_choices = [];
    }
    select_layers(...layer_nums) {
        this.layer_choices = layer_nums;
    }
    get is_cached() {
        return !!this.service_info.tileInfo;
    }
    get details() {
        return {
            DPI: 96,
            FORMAT: "png32",
            F: "image",
            TRANSPARENT: true,
            COMPRESSIONQUALITY: 100,
            LAYERS: `show:${this.layer_choices.join(',')}`
        };
    }
    get endpoints() {
        return this.urls;
    }
    get token() {
        return this._token;
    }
    get extent() {
        var _a, _b;
        const extent = (_b = (_a = this.service_info.fullExtent) !== null && _a !== void 0 ? _a : this.service_info.extent) !== null && _b !== void 0 ? _b : this.service_info.initialExtent;
        if (!extent)
            return [0, 0, 0, 0];
        return [
            extent.xmin,
            extent.ymin,
            extent.xmax,
            extent.ymax
        ];
    }
    try_wkid(sr) {
        if (!sr)
            return null;
        if (typeof sr.latestWkid === 'number')
            return sr.latestWkid;
        if (typeof sr.wkid === 'number')
            return sr.wkid;
        return null;
    }
    try_wkid_from_wkt(wkt) {
        if (!wkt)
            return null;
        if (wkt.includes("Web_Mercator_Auxiliary_Sphere"))
            return 3857;
        return null;
    }
    get projection() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        const primary = (_a = this.service_info.spatialReference) === null || _a === void 0 ? void 0 : _a.latestWkid;
        if (typeof primary === 'number') {
            return EPSG(primary);
        }
        const fallback_wkid = (_u = (_q = (_j = (_h = (_f = (_d = (_b = this.try_wkid(this.service_info.spatialReference)) !== null && _b !== void 0 ? _b : this.try_wkid((_c = this.service_info.fullExtent) === null || _c === void 0 ? void 0 : _c.spatialReference)) !== null && _d !== void 0 ? _d : this.try_wkid((_e = this.service_info.initialExtent) === null || _e === void 0 ? void 0 : _e.spatialReference)) !== null && _f !== void 0 ? _f : this.try_wkid((_g = this.service_info.extent) === null || _g === void 0 ? void 0 : _g.spatialReference)) !== null && _h !== void 0 ? _h : this.try_wkid(this.service_info.sourceSpatialReference)) !== null && _j !== void 0 ? _j : this.try_wkid_from_wkt((_m = (_l = (_k = this.service_info.extent) === null || _k === void 0 ? void 0 : _k.spatialReference) === null || _l === void 0 ? void 0 : _l.wkt) !== null && _m !== void 0 ? _m : (_p = (_o = this.service_info.extent) === null || _o === void 0 ? void 0 : _o.spatialReference) === null || _p === void 0 ? void 0 : _p.wkt2)) !== null && _q !== void 0 ? _q : this.try_wkid_from_wkt((_s = (_r = this.service_info.sourceSpatialReference) === null || _r === void 0 ? void 0 : _r.wkt) !== null && _s !== void 0 ? _s : (_t = this.service_info.sourceSpatialReference) === null || _t === void 0 ? void 0 : _t.wkt2)) !== null && _u !== void 0 ? _u : 3857;
        return EPSG(fallback_wkid);
    }
    get origin() {
        if (this.is_cached)
            return [this.service_info.tileInfo.origin.x, this.service_info.tileInfo.origin.y];
        return [0, 0];
    }
    get tile_size() {
        if (this.is_cached)
            return [this.service_info.tileInfo.rows, this.service_info.tileInfo.cols];
        return [0, 0];
    }
    get cached_resolutions() {
        if (this.is_cached)
            return this.service_info.tileInfo.lods.map(l => l.resolution);
        return [];
    }
}
